<template>
    <div v-if="pageData" class="static-accept-page static-page">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-12 page-content">
                    <div class="mb-4" v-html="pageData?.content?.content"></div>

                    <div class="d-flex justify-content-center legal-text" v-html="pageData?.content?.legal_text"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { useStore } from 'vuex'

export default {
    setup() {
        const store = useStore()

        return {
            store,
        }
    },
    computed: {
        pageData: function () {
            if (this.store.state.global.page) {
                this.emitter.emit('pageData:loaded')

                return this.store.state.global.page
            }

            return null
        },
    },
}
</script>

<style lang="scss" scoped></style>
